import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import Text from '../Text/Text';
import alertIcon from './assets/error-alert-icon.png';
import hideVisually from '../../../theme/shared/hideVisually';
/**
 * Input component
 */

var InputField = styled.input.withConfig({
  displayName: "Input__InputField",
  componentId: "bcqy1o-0"
})(["font-family:", ";font-weight:400;position:relative;box-sizing:border-box;width:100%;padding:13px;font-size:", ";background-color:", ";border:1px solid;border-color:", ";box-shadow:none;appearance:none;color:", ";:focus{border:1px solid ", ";}:focus::placeholder{color:", ";}@media ", "{max-width:290px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamilies('Montserrat');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontSize('m');
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.color('white');
}, function (_ref4) {
  var theme = _ref4.theme,
      error = _ref4.error;
  return !error ? theme.color('black') : theme.color('red');
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.color('black');
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.color('grey_for_forms');
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.color('grey_for_forms');
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.breakpoint('small');
});
/**
 * Label component
 */

var Label = styled.label.withConfig({
  displayName: "Input__Label",
  componentId: "bcqy1o-1"
})(["display:flex;flex-direction:column;"]);
/**
 * Text error component
 */

var ErrorText = styled(Text).withConfig({
  displayName: "Input__ErrorText",
  componentId: "bcqy1o-2"
})(["display:inline-block;color:red;font-weight:", ";:before{position:relative;content:'';top:2px;vertical-align:middle;margin-right:6px;background:url(", ") left 0/100% no-repeat;width:18px;height:19px;display:inline-block;vertical-align:top;color:", ";}"], function (_ref9) {
  var weight = _ref9.weight;
  return weight;
}, alertIcon, function (_ref10) {
  var theme = _ref10.theme;
  return theme.color('red');
});
/**
 * Label text component
 */

var TextLabel = styled(Text).withConfig({
  displayName: "Input__TextLabel",
  componentId: "bcqy1o-3"
})(["visibility:", ";"], function (_ref11) {
  var showLabel = _ref11.showLabel;
  return !showLabel && hideVisually;
});

var Input = function Input(_ref12) {
  var errorMsg = _ref12.errorMsg,
      id = _ref12.id,
      label = _ref12.label,
      showLabel = _ref12.showLabel,
      type = _ref12.type,
      hasAria = _ref12.hasAria,
      rest = _objectWithoutProperties(_ref12, ["errorMsg", "id", "label", "showLabel", "type", "hasAria"]);

  var error = errorMsg && errorMsg.length > 0;

  var labelRest = _objectSpread({}, rest); // Remove unrelated attributes to label element


  Object.keys(labelRest).map(function (propKey) {
    if (['value', 'name', 'placeholder', 'role'].includes(propKey)) {
      delete labelRest[propKey];
    } else if (propKey.match(/^aria-/) && propKey !== 'aria-label') {
      delete labelRest[propKey];
    }

    return true;
  });
  return React.createElement(Label, Object.assign({
    htmlFor: id
  }, labelRest), React.createElement(TextLabel, {
    showLabel: showLabel,
    weight: "bold"
  }, label), React.createElement(InputField, Object.assign({
    id: id,
    type: type
  }, rest, {
    error: error ? 1 : 0,
    "aria-describedby": hasAria ? id : undefined
  })), error && React.createElement(ErrorText, {
    size: "sm"
  }, errorMsg));
};

Input.defaultProps = {
  showLabel: true,
  hasAria: true,
  placeholder: '',
  errorMsg: ''
};
export default Input;